import styled, {css} from 'styled-components'
import {Text, TextProps} from '@/components/ui/text/Text'

export const StyledDetailsInformationPrimaryTextError = styled(Text)<TextProps>(
    ({theme: {palette}}) => css`
        color: ${palette.orange['800']};
    `
)

export const StyledDetailsInformationSecondaryText = styled(Text)<TextProps>(
    () => css`
        & > b {
            font-weight: 700;
        }
    `
)
